/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { FocusArea } from '../enums/focus-area';
import { PracticeAreaEnum } from '../enums/practice-area-enum';
import { SkillGroup } from '../enums/skill-group';
import { ExperienceEntity } from './experience-entity';
export class DataScienceSuggestedSkillEntity extends Entity {
  createdAt: string | null = null;
  experience: ExperienceEntity | null = null;
  experienceId: string | null = null;
  focusArea: FocusArea = null as unknown as never;
  id: string = '';
  legalSkills: string[] | null = null;
  practiceArea: PracticeAreaEnum = null as unknown as never;
  skillGroup: SkillGroup | null = null;
  updatedAt: string | null = null;
  static override key = 'DataScienceSuggestedSkill';
  static override get schema() {
    return {
      experience: ExperienceEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'DataScienceSuggestedSkill' in input
    ) {
      const { DataScienceSuggestedSkill: wrapped, ...rest } = input as {
        DataScienceSuggestedSkill: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}